module.exports = __webpack_public_path__ + "img/2.af1d8900.webp";